const asText = (value) => typeof value === "string" ? value.trim() : "";

const isRealNameStatusResponse = (data) => !!data && typeof data === "object" && typeof data.authenticated === "boolean";

const maskRealName = (value) => {
    const name = asText(value);
    if (!name) return "";
    return `${name.slice(0, 1)}*`;
};

const normalizeRealNameStatus = (data = {}) => {
    if (data.authenticated !== true) {
        return {
            status: "UNVERIFIED",
            name: "",
            maskedIdNumber: "",
            reviewedAt: "",
        };
    }

    return {
        status: "APPROVED",
        name: asText(data.realNameMasked),
        maskedIdNumber: asText(data.idCardMasked),
        reviewedAt: asText(data.authenticatedAt),
    };
};

module.exports = {
    isRealNameStatusResponse,
    maskRealName,
    normalizeRealNameStatus,
};
